// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__main-container__B4qiH {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;
}
.index-module__main-container__B4qiH .index-module__dropdown-container__Ar9z3 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.index-module__main-container__B4qiH .index-module__dropdown_label__e28VM {
  display: block;
  font-size: 16px;
  font-weight: bolder;
}
.index-module__main-container__B4qiH .index-module__dropdown__selector__p1heS {
  width: 13vw;
  font-size: 18px;
}
@media only screen and (max-width: 1024px) {
  .index-module__main-container__B4qiH .index-module__dropdown__selector__p1heS {
    width: 16vw;
  }
}
@media only screen and (max-width: 768px) {
  .index-module__main-container__B4qiH .index-module__dropdown__selector__p1heS {
    width: 18vw;
  }
  .index-module__main-container__B4qiH .index-module__dropdown_label__e28VM {
    font-size: 14px;
  }
}
@media only screen and (max-width: 430px) {
  .index-module__main-container__B4qiH {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 0.5rem;
    margin-top: 5px;
  }
  .index-module__main-container__B4qiH .index-module__dropdown__selector__p1heS {
    width: 35vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CustomerLocationFilter/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".main-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1.5rem;\n}\n.main-container .dropdown-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.main-container .dropdown_label {\n  display: block;\n  font-size: 16px;\n  font-weight: bolder;\n}\n.main-container .dropdown__selector {\n  width: 13vw;\n  font-size: 18px;\n}\n@media only screen and (max-width: 1024px) {\n  .main-container .dropdown__selector {\n    width: 16vw;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .main-container .dropdown__selector {\n    width: 18vw;\n  }\n  .main-container .dropdown_label {\n    font-size: 14px;\n  }\n}\n@media only screen and (max-width: 430px) {\n  .main-container {\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-end;\n    gap: 0.5rem;\n    margin-top: 5px;\n  }\n  .main-container .dropdown__selector {\n    width: 35vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-container": `index-module__main-container__B4qiH`,
	"dropdown-container": `index-module__dropdown-container__Ar9z3`,
	"dropdown_label": `index-module__dropdown_label__e28VM`,
	"dropdown__selector": `index-module__dropdown__selector__p1heS`
};
export default ___CSS_LOADER_EXPORT___;
